import React from "react";
import { DataGridView, Input } from "@neumetric/blueprint-lib/components";
import { riskActions, getRatingListByType } from "../../store";
import { useDispatch, useSelector } from "react-redux";

const RATING_TYPE_OPTIONS = [
  { id: "confidentiality", label: "Confidentiality" },
  { id: "integrity", label: "Integrity" },
  { id: "availability", label: "Availability" },
  { id: "security", label: "Security" },
  { id: "privacy", label: "Privacy" },
  { id: "impact", label: "Impact" },
];

export const RatingsTrackerScreen = () => {
  const dispatch = useDispatch();
  const _dvgRef = React.useRef(null);
  const [selectedType, setSelectedType] = React.useState("confidentiality");
  const selectedLabel =
    RATING_TYPE_OPTIONS.find((o) => o.id === selectedType)?.label ||
    "Description";

  React.useEffect(() => {
    dispatch(riskActions.fetchRatings());
  }, [dispatch]);

  const columns = React.useMemo(() => {
    return [
      {
        dataIndex: "rating",
        typeRepresentation: "DOT",
        title: "Rating",
        width: "15%",
        sortableFlag: true,
        filterFlag: true,
      },
      {
        dataIndex: "score",
        typeRepresentation: "TEXT",
        title: "Score",
        width: "10%",
      },
      {
        dataIndex: "description",
        typeRepresentation: "TEXTAREA",
        title: selectedLabel,
        width: "75%",
        rows: 3,
      },
    ];
  }, [selectedLabel]);

  const normalizeDescription = (s = "") => {
    if (!s) return s;

    // Ensure "Recovery from ..." starts on a new paragraph (blank line above)
    if (s.includes("Recovery from") && !s.includes("\n\nRecovery from")) {
      s = s.replace(/\s*Recovery from/g, "\n\nRecovery from");
    }

    // Optional: also break after the first sentence (only if not already multiline)
    if (!s.includes("\n") && s.includes(". ")) {
      const firstDot = s.indexOf(". ");
      if (firstDot !== -1) {
        s = s.slice(0, firstDot + 1) + "\n" + s.slice(firstDot + 2);
      }
    }

    return s;
  };

  const rows = useSelector(getRatingListByType.bind(null, selectedType)) || [];
  const normalizedRows = React.useMemo(
    () =>
      rows.map((r) => ({
        ...r,
        description: normalizeDescription(r.description),
      })),
    [rows]
  );

  return (
    <div
      className="w-100 h-100 nm-ratings-dgv"
      style={{ border: "1px solid #E0E0E0" }}
    >
      {/* Header row */}
      <div
        className="d-flex align-center pl-7"
        style={{
          borderBottom: "1px solid #E0E0E0",
          backgroundColor: "rgba(250, 250, 250, 1)",
        }}
      >
        <span className="ff-exo2 fw-600 f16" style={{ color: "#333" }}>
          CIASP Rating &amp; Description
        </span>

        <div
          style={{
            marginLeft: 30,
            width: 180,
            transform: "translateY(12px)",
          }}
        >
          <Input
            typeRepresentation="DROPDOWN"
            placeholder="Select Rating Type"
            options={RATING_TYPE_OPTIONS}
            value={selectedType}
            onChange={(val) => setSelectedType(val)}
            searchableFlag={false}
            multiSelection={false}
            template="DEFAULT"
          />
        </div>
      </div>
      <div className=" h-100">
        <DataGridView
          ref={_dvgRef}
          columns={columns}
          dataSource={normalizedRows}
          EmptyComponent={
            <span className="ff-exo2 f16 c777">
              There are no ratings right now!
            </span>
          }
        />
      </div>
    </div>
  );
};
